import { STATUS } from 'utils/enums'
import './StatusIndicator.css'

interface IStatusIndicator {
    status: STATUS
}

const StatusIndicator = ({status}: IStatusIndicator) => {
  return (
    <div className='status-indicator'>
        <span className={`indicator ${status}`}></span>
    </div>
  )
}

export default StatusIndicator